import { RowBondDataDetail, IFile } from 'pages/bond-data-management/interface'
import React from 'react'
import BondDataImportDetailTable from './components/bond-data-import-detail-table'
import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { BOND_DATA_MANAGEMENT } from 'constants/common'

interface Props {
  fileOverview: IFile
  bondData: RowBondDataDetail[]
  fetchMoreData: LazyQueryExecFunction<any, OperationVariables>
}

const DetailBondFile: React.FC<Props> = ({ fileOverview, bondData, fetchMoreData }) => {
  const classNameForStatus = (status: string) => {
    let className = ''
    const { PROCESSED, FAILED, PROCESSING } = BOND_DATA_MANAGEMENT.FILE_STATUS

    switch (status) {
      case PROCESSED:
        className = 'text-green-500'
        break
      case FAILED:
        className = 'text-red-500'
        break
      case PROCESSING:
        className = 'text-yellow-500'
        break
      default:
        break
    }

    return className
  }

  return (
    <div>
      <div className="flex space-x-6">
        <p>
          Total bond: <strong>{fileOverview?.totalRow?.toLocaleString()}</strong>
        </p>
        <p>
          Total successes:{' '}
          <strong className="text-green-900">{fileOverview?.totalSuccess?.toLocaleString()}</strong>
        </p>
        <p>
          Total failures:{' '}
          <strong className="text-red-900">{fileOverview?.totalFailure?.toLocaleString()}</strong>
        </p>
      </div>
      <div className="flex flex-col">
        <p>
          Status:{' '}
          <strong className={classNameForStatus(fileOverview.status)}>
            {fileOverview.status}
          </strong>
        </p>
        <p>Upload by: {fileOverview.createdBy}</p>
        <p>Upload at: {fileOverview.createdAt}</p>
      </div>
      <BondDataImportDetailTable
        data={bondData}
        fetchMoreBondData={fetchMoreData}
        fileId={fileOverview.fileId}
      />
    </div>
  )
}

export default DetailBondFile
